var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container"},[_c('iframe',{ref:"iframe",attrs:{"src":_vm.url,"width":"100%","frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }